<template>
  <div class="loading-page"
       v-if="loadingStyle">
    <div class="loading">
      <img src="@/assets/home/zylc-icon.png"
           class="zylc-icon">
      <p class="loading-num">{{percent}}%</p>
      <p class="loading-tips">loading...</p>
    </div>
  </div>
</template>

<script>
import { loadImg } from '@/utils'
export default {
  data () {
    return {
      loadingStyle: true,
      percent: 0,
      loadResource: [
        require('../../assets/home/home-bg.png'),
        require('../../assets/guess/guess-bg.png'),
        require('../../assets/poster/poster-bg.png'),
        require('../../assets/lottery/lottery-bg.png'),
        require('../../assets/home/home-title.png'),
        require('../../assets/home/listen-icon.png'),
        require('../../assets/home/zylc-icon.png'),
        require('../../assets/home/sure-btn.png'),
        require('../../assets/home/tips-icon.png'),
        require('../../assets/home/ischoose.png')
      ]
    }
  },
  methods: {
    async init () {
      this.$parent.$parent.$refs.music.hideMusic()
      let percent = 0
      for (const resource of this.loadResource) {
        await loadImg(resource)
        percent++
        await this.goTime(Math.floor((percent / this.loadResource.length) * 100))
      }
      this.loadingStyle = false
      this.$parent.$parent.$refs.music.toShowMusic()
      // this.$parent.$parent.$refs.music.toPlay()
    },
    goTime (percent) {
      return new Promise(resolve => {
        const timer = setInterval(() => {
          if (this.percent < percent && this.percent < 100) {
            this.percent++
          } else {
            clearInterval(timer)
            resolve()
          }
        }, 5)
      })
    }
  },
  mounted () {
    this.init()
    // console.log('121', this.$parent.$parent.$refs.music)
  }
}
</script>

<style lang="scss" scoped>
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 1700px;
  height: 100vh;
  background-color: #fbfcee;
  z-index: 999;
}
.loading {
  width: 750px;
  height: 1700px;
  background: url(~@/assets/home/loading-bg.png) no-repeat;
  background-size: 100%;
  padding-top: 290px;
  position: relative;
  .zylc-icon {
    position: absolute;
    width: 212px;
    height: 52px;
    top: 57px;
    left: 21px;
  }
  .loading-num {
    width: 100%;
    font-size: 110px;
    font-family: HappyZcool-2016;
    font-weight: 400;
    color: #1090b0;
    text-align: center;
  }
  .loading-tips {
    width: 100%;
    font-size: 48px;
    font-family: HappyZcool-2016;
    font-weight: 400;
    color: #1090b0;
    text-align: center;
  }
}
</style>